"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var hasClipboardData = function (w) {
    return Object.prototype.hasOwnProperty.call(w, 'clipboardData');
};
var getClipboardData = function (w) {
    if (hasClipboardData(w)) {
        return w.clipboardData;
    }
    return null;
};
var isClipboardApiEnabled = function (navigator) { return (typeof navigator === 'object' &&
    typeof navigator.clipboard === 'object'); };
var NOT_ALLOWED_ERROR = new Error('NotAllowed');
var zeroStyles = function (i) {
    var e_1, _a;
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    try {
        for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
            var property = properties_1_1.value;
            i.style.setProperty(property, '0');
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
var createInput = function () {
    var i = document.createElement('input');
    i.setAttribute('size', '0');
    zeroStyles(i, 'border-width', 'bottom', 'margin-left', 'margin-top', 'outline-width', 'padding-bottom', 'padding-left', 'padding-right', 'padding-top', 'right');
    i.style.setProperty('box-sizing', 'border-box');
    i.style.setProperty('height', '1px');
    i.style.setProperty('margin-bottom', '-1px');
    i.style.setProperty('margin-right', '-1px');
    i.style.setProperty('max-height', '1px');
    i.style.setProperty('max-width', '1px');
    i.style.setProperty('min-height', '1px');
    i.style.setProperty('min-width', '1px');
    i.style.setProperty('outline-color', 'transparent');
    i.style.setProperty('position', 'absolute');
    i.style.setProperty('width', '1px');
    document.body.appendChild(i);
    return i;
};
var removeInput = function (i) {
    document.body.removeChild(i);
};
var read = function () {
    var i = createInput();
    i.focus();
    var success = document.execCommand('paste');
    if (!success) {
        removeInput(i);
        throw NOT_ALLOWED_ERROR;
    }
    var value = i.value;
    removeInput(i);
    return value;
};
var write = function (text) {
    var i = createInput();
    i.setAttribute('value', text);
    i.select();
    var success = document.execCommand('copy');
    removeInput(i);
    if (!success) {
        throw NOT_ALLOWED_ERROR;
    }
};
var useClippy = function () {
    var _a = __read(React.useState(''), 2), clipboard = _a[0], setClipboard = _a[1];
    React.useEffect(function () {
        if (isClipboardApiEnabled(navigator)) {
            var clipboardListener_1 = function (_a) {
                var clipboardData = _a.clipboardData;
                var dataTransfer = clipboardData ||
                    getClipboardData(window) ||
                    null;
                if (dataTransfer) {
                    var text = dataTransfer.getData('text/plain');
                    if (clipboard !== text) {
                        setClipboard(text);
                    }
                }
            };
            navigator.clipboard.addEventListener('copy', clipboardListener_1);
            navigator.clipboard.addEventListener('cut', clipboardListener_1);
            return function () {
                if (isClipboardApiEnabled(navigator)) {
                    navigator.clipboard.removeEventListener('copy', clipboardListener_1);
                    navigator.clipboard.removeEventListener('cut', clipboardListener_1);
                }
            };
        }
        var clipboardListener = function () {
            try {
                var selection = document.getSelection();
                if (selection) {
                    setClipboard(selection.toString());
                }
            }
            catch (_e) { }
        };
        document.addEventListener('copy', clipboardListener);
        document.addEventListener('cut', clipboardListener);
        return function () {
            document.removeEventListener('copy', clipboardListener);
            document.removeEventListener('cut', clipboardListener);
        };
    }, [clipboard]);
    var syncClipboard = React.useCallback(function (text) { return __awaiter(_this, void 0, void 0, function () {
        var e_2, _e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 1, , 6]);
                    write(text);
                    setClipboard(text);
                    return [3, 6];
                case 1:
                    e_2 = _a.sent();
                    if (!isClipboardApiEnabled(navigator)) return [3, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, navigator.clipboard.writeText(text)];
                case 3:
                    _a.sent();
                    setClipboard(text);
                    return [3, 5];
                case 4:
                    _e_1 = _a.sent();
                    return [3, 5];
                case 5: return [3, 6];
                case 6: return [2];
            }
        });
    }); }, []);
    React.useLayoutEffect(function () {
        try {
            var text = read();
            if (clipboard !== text) {
                setClipboard(text);
            }
        }
        catch (e) {
            if (isClipboardApiEnabled(navigator)) {
                (function () { return __awaiter(_this, void 0, void 0, function () {
                    var text, _e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4, navigator.clipboard.readText()];
                            case 1:
                                text = _a.sent();
                                if (clipboard !== text) {
                                    setClipboard(text);
                                }
                                return [3, 3];
                            case 2:
                                _e_2 = _a.sent();
                                return [3, 3];
                            case 3: return [2];
                        }
                    });
                }); })();
            }
        }
    }, [clipboard]);
    return [
        clipboard,
        syncClipboard,
    ];
};
exports.default = useClippy;
module.exports = useClippy;
module.exports.default = useClippy;
